import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import List from './components/List'
import Detail from './components/Detail'
import TemplateDetail from './components/Templates/Detail'
import { paths } from '@/utils/path'

const MailerCampaignModule: RouteObject = {
    path: paths.mailerCampaign,
    children: [
        {
            path: '',
            element: <List />,
        },
        // Campaign routes
        {
            path: 'new',
            element: <Detail />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
        {
            path: ':id/edit',
            element: <Detail />,
        },
        // Template routes
        {
            path: 'templates/new',
            element: <TemplateDetail />,
        },
        {
            path: 'templates/:id',
            element: <TemplateDetail />,
        },
        {
            path: 'templates/:id/edit',
            element: <TemplateDetail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default MailerCampaignModule
